import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const ClassSubjectReadSlice = createSlice({
  name: "ClassSubjectReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    ClassSubjectRead: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successClassSubjectRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureClassSubjectRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearClassSubjectRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  ClassSubjectRead,
  successClassSubjectRead,
  failureClassSubjectRead,
  clearClassSubjectRead,
} = ClassSubjectReadSlice.actions;

export default ClassSubjectReadSlice.reducer;
